import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCustomer } from "../customHooks/useCustomer";

export default function ProtectedCustomerRoute({ children }: { children: any }) {
    const navigate = useNavigate();
    const { country, language } = useParams() as {
        country: string;
        language: string;
      };    

    const {customerState} = useCustomer()
    const urlParams = new URLSearchParams(window.location.search);
    const otc = urlParams.get("otc");

    useEffect(() => {
        if (otc && !customerState) {
            navigate(`/sign_up/${country}/${language}?otc=true`);
        }
    }, [otc, customerState, navigate, language]);

    // Don't render anything while redirecting
    if (otc && !customerState) return null;

    return children;
}